export interface Grupo {
    id?: string,
    nombre: string,
    descripcion: string
}

export const defaultGrupo = { id: '', nombre: '', descripcion: '' };